import { formatCurrency } from '~/lib/CurrencyHelpers.js';
import {
    BlockDescription,
    SelectionImage,
} from '~/components/forms/questions/components/SelectionBlock.jsx';
import { FormPart, FormStateName, part, state } from '~/lib/FormCssApi';

const SelectionSelectedBlock = ({
    image,
    title,
    description,
    price,
    onChange,
    selectedRightContent,
}) => {
    return (
        <section
            {...part(FormPart.SELECTION_SELECTED)}
            {...state(FormStateName.SELECTED)}
            className="choose-block choose-block-selected flex"
        >
            {!!image && (
                <div onClick={() => onChange()} className="pl-6">
                    <SelectionImage image={image} />
                </div>
            )}
            <div className="flex-1 p-6" onClick={() => onChange()}>
                <p {...part(FormPart.SELECTION_TITLE)} className="font-medium">
                    {title || ''}
                </p>
                <p {...part(FormPart.SELECTION_PRICE)}>
                    {price ? formatCurrency(price) : ''}
                </p>
                {!!description && (
                    <BlockDescription description={description} />
                )}
            </div>
            <div>
                {!!selectedRightContent && (
                    <div className="pr-6 pb-4">{selectedRightContent}</div>
                )}
                {!selectedRightContent && (
                    <button
                        {...part(FormPart.SELECTION_CHANGE)}
                        type="button"
                        onClick={() => onChange()}
                        className="mr-6 btn-inverse btn-small text-sm btn-light-pill-sm uppercase"
                    >
                        Change
                    </button>
                )}
            </div>
        </section>
    );
};

export default SelectionSelectedBlock;
